var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._b({ staticClass: "vx-breadcrumb" }, "div", _vm.$attrs, false),
    [
      _vm.hasBreadcrumb
        ? _c(
            "ul",
            { staticClass: "flex flex-wrap items-center" },
            [
              _c(
                "li",
                { staticClass: "inline-flex items-end" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/" } },
                    [
                      _c("feather-icon", {
                        staticClass: "h-5 w-5 mb-1 stroke-current text-primary",
                        attrs: { icon: "HomeIcon" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "span",
                    { staticClass: "breadcrumb-separator mx-2" },
                    [
                      _c("feather-icon", {
                        staticClass: "w-4 h-4",
                        attrs: {
                          icon: _vm.isRTL
                            ? "ChevronsLeftIcon"
                            : "ChevronsRightIcon"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._l(_vm.middleCrumbs, function(link, index) {
                return _c(
                  "li",
                  {
                    key: "crumb-mid-" + index,
                    staticClass: "inline-flex items-center"
                  },
                  [
                    link.url
                      ? _c(
                          "router-link",
                          {
                            staticClass: "breadcrumb-link text-neutral",
                            attrs: { to: link.url }
                          },
                          [_vm._v(_vm._s(_vm.label(link.title)))]
                        )
                      : _c(
                          "span",
                          { staticClass: "text-neutral cursor-default" },
                          [_vm._v(_vm._s(_vm.label(link.title)))]
                        ),
                    _c(
                      "span",
                      {
                        staticClass:
                          "breadcrumb-separator mx-2 flex items-start"
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "w-4 h-4",
                          attrs: {
                            icon: _vm.isRTL
                              ? "ChevronsLeftIcon"
                              : "ChevronsRightIcon"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _vm.lastCrumb && _vm.lastCrumb.active !== false
                ? _c("li", { staticClass: "inline-flex" }, [
                    _c("span", { staticClass: "cursor-default text-neutral" }, [
                      _vm._v(_vm._s(_vm.label(_vm.lastCrumb.title)))
                    ])
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }